import React from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { all_routes } from "../../router/all_routes";

const Support = () => {
  return (
    <div className="main-wrapper">
      <div className="text-center mt-4">
        <ImageWithBasePath
          src="assets/images/logo.png"
          alt="iKidz"
          width={150}
          // height={200}
          className="img-fluid"
        />
      </div>

      <div className="container my-4">
        <div className="card shadow-sm">
          <div className="card-body p-4">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
              <h3 className="mb-0">Support</h3>
              <Link to={all_routes.login} className="btn btn-outline-primary btn-sm">
                Back to Login
              </Link>
            </div>

            <p className="text-muted mb-4">
              Need help with iKidz? Use the information below to reach our team.
            </p>

            <div className="row g-3">
              <div className="col-12 col-md-6">
                <div className="border rounded p-3 h-100 bg-white">
                  <h6 className="mb-2">Contact</h6>
                  <div className="text-muted">
                    <div>Email: support@ikidz.example</div>
                    <div>Phone: +1 (000) 000-0000</div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <div className="border rounded p-3 h-100 bg-white">
                  <h6 className="mb-2">Hours</h6>
                  <div className="text-muted">
                    <div>Mon–Fri: 9:00 AM – 6:00 PM</div>
                    <div>Sat–Sun: Closed</div>
                  </div>
                </div>
              </div>
            </div>

            <hr className="my-4" />

            <h6 className="mb-2">Common questions</h6>
            <ul className="text-muted mb-0">
              <li>How do I reset my password?</li>
              <li>Why can’t I log in?</li>
              <li>How do I update my profile details?</li>
              <li>How do I report an issue?</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;

